








import { computed, defineComponent, PropType } from '@vue/composition-api';
import AppText from '@berlin-front/common/components/elements/AppText';
import { bemx } from '@berlin-front/common/utils';
import { LETTER_SPACING, LineHeight, LINE_HEIGHT } from '../AppText/composable';

export default defineComponent({
  name: 'AttributeValue',
  components: {
    AppText,
  },

  props: {
    /**
     * 行の高さ。
     * 1.5にしたい場合に限り、個別に指定する。
     */
    lineHeight: {
      type: String as PropType<LineHeight>,
      required: false,
      default: LINE_HEIGHT.HEIGHT125,
    },
  },

  setup() {
    const className = computed(() => bemx('AttributeValue'));
    return {
      className,
      text: {
        spacing: {
          spacing1: LETTER_SPACING.SPACING1,
        },
      },
    };
  },
});
